module.exports = __webpack_public_path__ + "images/hongbao.png";